import { createBrowserRouter } from 'react-router-dom';
import HOME_PAGE_ROUTES from '../component/home-page/home-page-routes';
import AUTH_ROUTES from '../component/authentication/auth-routes';
import PrivateRouteGuard from 'app/guards/private-route';
import RouteAccessGuard from 'app/guards/route-access-guard';
import GATE_ROUTES from 'modules/gate/routers/GateRouter';
import AppRouteErrorPage from 'component/global/error-boundary/AppRouteErrorPage';
import { PortalPage } from 'modules/gate/pages/PortalPage';
import PortalFrameCache from 'modules/gate/components/PortalFrameCache';
// import WORKSPACE_ROUTES from './component/workspace/workspace-routes';
// import WorkspaceComponent from './component/workspace/workspace-component';

const ROUTES = createBrowserRouter([
    {
        // AUTHENTICATED ROUTE
        path: "",
        element: <PrivateRouteGuard />,
        children: [
            {
                path: "",
                element: <RouteAccessGuard />,
                children: [
                    {
                        path: "",
                        children: HOME_PAGE_ROUTES
                    },
                    {
                        path: "g",
                        children: GATE_ROUTES
                    },
                ]
            }
        ],
        errorElement: <AppRouteErrorPage />
    },
    // NON AUTHENTICATED ROUTE
    {
        path: "pub",
        element: <PortalFrameCache />,
        errorElement: <AppRouteErrorPage />,
        children: [
            {
                path: ":pageId/*",
                element: <PortalPage publicOnly />,
            }
        ]
    },
    {
        path: "login",
        children: AUTH_ROUTES,
        errorElement: <AppRouteErrorPage />
    }
]);
export default ROUTES;
